import {
    map,
    assign
} from "../../../../common/utils";
import { getDataIndex } from "./utils";

// grid
export function makeGrid(opts) {
    return assign({
        top: 5,
        left: 40,
        right: 5,
        bottom: 5,
        show: true,
        backgroundColor: '#000',
        borderColor: '#262617'
    }, opts)
}

// tooltip
export function makeTooltip(klines, opts,
    formatter) {
    opts = assign({}, opts)
    return {
        trigger: 'axis',
        axisPointer: {
            type: 'cross'
        },
        formatter(params) {
            const dataIndex = getDataIndex(params)
            return dataIndex >= 0 ? formatter(klines, dataIndex, opts) : 0;
        }
    }
}

// 获取天数
export function makeDataDays(klines) {
    return klines ? map(klines, (k, i) => `第${i+1}天`) : [];
}
